// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__2AHO2","boxTitle":"Qualiphy_boxTitle__SSLI9","box":"Qualiphy_box__3Vvv4","toggleWrap":"Qualiphy_toggleWrap__2ukdx"};